import type { FunctionComponent } from "react";
import { CreateCampaignAdminPartial } from "../../../partials/admin/campaigns/create-campaign.admin.partials";
import { useParams } from "react-router-dom";

export const CreateCampaignBrandAdminScreen: FunctionComponent = () => {
	const { brandId } = useParams();

	if (!brandId) {
		throw new Error("brand id not found");
	}

	return <CreateCampaignAdminPartial brandId={brandId} />;
};
